var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-dental.0380ebd6.png","uri@2x": __webpack_public_path__ + "icon-dental.641eac06.png","uri@3x": __webpack_public_path__ + "icon-dental.532767ec.png",
    width: 20,
    height: 20
});